import { FC } from 'react';
import { Loader } from '../../../../components/loader/loader';
import { Page } from '../../../../components/page/page';
import { HasAccess } from '../../../../features/has-access/has-access';
import { useDashboardStore } from '../../../../store/use-dashboard-store';
import { DashboardCardProps } from './dashboard-components/dashboard-cards/dashboard-card/dashboard-card';
import { DashboardCards } from './dashboard-components/dashboard-cards/dashboard-cards';
import { DashboardCharts } from './dashboard-components/dashboard-charts/dashboard-charts';
import { ChartProps } from './dashboard-components/dashboard-charts/use-dashboard-charts';
import { DashboardFilters } from './dashboard-components/dashboard-filters/dashboard-filters';
import './dashboard.css';

interface Props {
  cards?: DashboardCardProps[];
  chartsData: ChartProps[];
  dashboardsClassname?: string;
}

export const Dashboard: FC<Props> = (props) => {
  const { chartsData, cards, dashboardsClassname } = props;
  const { isLoading } = useDashboardStore();

  return (
    <HasAccess service="dashboard" permissions={['read', 'write']}>
      <Page>
        {isLoading && <Loader />}
        <DashboardFilters />
        <DashboardCards cards={cards} />
        <DashboardCharts className={dashboardsClassname} chartsData={chartsData} />
      </Page>
    </HasAccess>
  );
};
